import React, { Component } from 'react';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import withStyles from '@material-ui/core/styles/withStyles';
import PropTypes from 'prop-types';
import Buttoncontrol from "../GeneralUI/Buttoncontrol";
import Textfieldlabel from "../GeneralUI/Textfieldlabel";
import Grid from '@material-ui/core/Grid';
import InputLabel from '@material-ui/core/InputLabel';
import Button from '@material-ui/core/Button';
import PSelect from '../GeneralUI/PSelect'
import { SnackbarProvider, withSnackbar } from 'notistack';
import Tooltip from '@material-ui/core/Tooltip';
import Chip from '@material-ui/core/Chip';
import Visibility from '@material-ui/icons/Visibility';
import { getDocument } from '../../Actions/General';
import CustomizedExpansionPanel from '../GeneralUI/PExpansionpanels';
import Datagrid from '../GeneralUI/PDatagrid/'
import { withRouter } from 'react-router';
import Styles from '../GeneralUI/Styles';
import Utils from '../../Libs/utils';

class Usuario extends Component {
  state = {
    fields: {
      usuarioCodigo: null,
      usuarioNombre1: '',
      usuarioNombre2: '',
      usuarioApellido1: '',

      usuarioApellido2: '',
      usuarioContrasena: '',
      usuarioFechaNacimiento: '',

      tipdocCodigo: '',
      usuarioNumeroDocumento: '',
      usuarioCorreoElectronico: '',

      usuarioNotas: '',
      usuarioEstado: '',
      usuarioAvatar: '',
      usuarioNombreUsuario: '',
      createdAt: Utils.fullDateTime(),
      updatedAt: Utils.fullDateTime()
    },

    dataDatagridUsuarioAlmacenes: [{
      Almacen: { 'value': null, 'key': null ,'visible':true}
    }],

    dataDatagridUsuarioClientes: [{
      Cliente: { 'value': null, 'key': null ,'visible':true}
    }],

    dataDatagridUsuarioSucursales: [{
      Sucursal: { 'value': null, 'key': null ,'visible':true}
    }],

    dataDatagridUsuarioPaginas: [{
      Pagina: { 'value': null, 'key': null ,'visible':true}
    }],

    responseForm: { Message: '', typeMessage: '' }
  };

  componentDidMount() {
    const params = this.props.match.params;

    if (!params.id) {
      return;
    }

    getDocument({
      documentId: params.id,
      fieldName: 'usuarioCodigo',
      moduleName: params.module
    }).then(document => {
      if (!document) {
        return;
      }
      this.setState({ fields: document });
        getDocument({
          documentId: params.id,
          fieldName: 'usuario_codigo',
          moduleName: 'vw_usuario_almacenes_autorizados',
          isView: true,
          fields: ['almacen_codigo',
            'almacen_nombre'
          ],
          Limit: 50
        }).then(document => {
          if (!document) {
            return;
          }
            this.buildDetailUsuarioAlmacenesInterface(document);
        }).catch(ex => {
          console.log('index.jsx -- 137 > ex === ', ex);
        });

        getDocument({
          documentId: params.id,
          fieldName: 'usuario_codigo',
          moduleName: 'vw_usuario_sucursales_autorizadas',
          isView: true,
          fields: ['sucursal_codigo',
            'sucursal_nombre'
          ],
          Limit: 50
        }).then(document => {
          if (!document) {
            return;
          }
            this.buildDetailUsuarioSucursalesInterface(document);
        }).catch(ex => {
          console.log('index.jsx -- 137 > ex === ', ex);
        });

        getDocument({
          documentId: params.id,
          fieldName: 'usuario_codigo',
          moduleName: 'vw_usuario_clientes_autorizados',
          isView: true,
          fields: ['cliente_codigo',
            'cliente_razon_social'
          ],
          Limit: 50
        }).then(document => {
          if (!document) {
            return;
          }
            this.buildDetailUsuarioClientesInterface(document);
        }).catch(ex => {
          console.log('index.jsx -- 137 > ex === ', ex);
        });

        getDocument({
          documentId: params.id,
          fieldName: 'usuario_codigo',
          moduleName: 'vw_usuario_paginas_autorizadas',
          isView: true,
          fields: ['pagina_codigo',
            'pagina_nombre'
          ],
          Limit: 50
        }).then(document => {
          if (!document) {
            return;
          }
            this.buildDetailUsuarioPaginasInterface(document);
        }).catch(ex => {
          console.log('index.jsx -- 137 > ex === ', ex);
        });
    });

  }

   buildDetailUsuarioAlmacenesInterface = (data) => {
    let rows = data.map(row => {
      return {
        Almacen: { 'value': row.almacen_codigo, 'key': row.almacen_nombre, 'visible':true }
      };
    });
    this.setState({ dataDatagridUsuarioAlmacenes: rows });
  }

  buildDetailUsuarioClientesInterface = (data) => {
    let rows = data.map(row => {
      return {
        Cliente: { 'value': row.cliente_codigo, 'key': row.cliente_razon_social, 'visible':true }
      };
    });
    this.setState({ dataDatagridUsuarioClientes: rows });
  }

  buildDetailUsuarioSucursalesInterface = (data) => {
    let rows = data.map(row => {
      return {
        Sucursal: { 'value': row.sucursal_codigo, 'key': row.sucursal_nombre, 'visible':true }
      };
    });
    this.setState({ dataDatagridUsuarioSucursales: rows });
  }

  buildDetailUsuarioPaginasInterface = (data) => {
    let rows = data.map(row => {
      return {
        Pagina: { 'value': row.pagina_codigo, 'key': row.pagina_ruta, 'visible':true }
      };
    });
    this.setState({ dataDatagridUsuarioPaginas: rows });
  }

  handleSeguir = () => {
    alert('Seguimiento registrado.');
  }

  handleChange = (event) => {
    let { fields } = this.state;
    if (event.target.type === 'time') {
      fields[event.target.id] = event.target.value;
    } else if (event.target.type === 'number') {
      fields[event.target.id] = event.target.value;
    } else {
      fields[event.target.id] = event.target.value.toUpperCase();
    }
    this.setState({ fields });
  }

  handleDatagrid = (data) => {
    return null;
  }

  save = (response) => {
  this.setState({
    fields: response.data,
    responseForm: response.responseForm
  });
    this.props.enqueueSnackbar(
      response.responseForm.Message,
      { variant: response.responseForm.typeMessage }
    );
  }

  handleAuto = (autoCompleteValue) => {
    this.setState({ colorAutoComplete: autoCompleteValue });
  }

  render() {
    return (
      <Paper elevation={1} className={this.props.classes.mainPaper}>

        <form className={this.props.form} onSubmit={e => e.preventDefault()}>
          <Grid container spacing={3} className={this.props.classes.gridForm}>
            <InputLabel id="usuarioCodigo"
              className={this.props.classes.tittleLabelForm}>Usuario</InputLabel>
            <Grid item xs={6} className={this.props.classes.chipTitle}>
              {(this.state.fields.usuarioCodigo !== null) ?
                (<Chip
                  label={this.state.fields["usuarioCodigo"]}
                  clickable
                  color="primary"
                  onDelete={this.handleSeguir}
                  deleteIcon={<Tooltip title="Seguir" placement="right-start"><Visibility /></Tooltip>}
                />) : ''
              }
            </Grid>
          </Grid>

          <Grid container spacing={4}>
            <Grid item xs={3} className={this.props.classes.gridForm}>
              <TextField id="usuarioNombre1" label="Primer Nombre (*)" type="text"
                InputProps={{
                  classes: {
                    root: this.props.classes.textFieldInput
                  }
                }} textPrimary
                InputLabelProps={{
                  classes: {
                    root: this.props.classes.textFieldLabel
                  }
                }}
                fullWidth margin="normal" variant="outlined" onChange={this.handleChange}
                value={this.state.fields["usuarioNombre1"]}
              />
            </Grid>

            <Grid item xs={3} className={this.props.classes.gridForm}>
              <TextField id="usuarioNombre2" label="Segundo Nombre (*)" type="text"

                fullWidth margin="normal" variant="outlined"
                onChange={this.handleChange}
                value={this.state.fields["usuarioNombre2"]}
              />
            </Grid>
            <Grid item xs={3} className={this.props.classes.gridForm}>
              <TextField id="usuarioApellido1" label="Primer Apellido (*)" type="text"

                fullWidth margin="normal" variant="outlined" onChange={this.handleChange}
                value={this.state.fields["usuarioApellido1"]}
              />
            </Grid>
          </Grid>

          <Grid container spacing={4}>
            <Grid item xs={3} className={this.props.classes.gridForm}>
              <TextField id="usuarioApellido2" label="Segundo Apellido (*)" type="text"

                fullWidth margin="normal" variant="outlined" onChange={this.handleChange}
                value={this.state.fields["usuarioApellido2"]}
              />
            </Grid>
            <Grid item xs={3} className={this.props.classes.gridForm}>
              <TextField id="usuarioNombreUsuario" label="Login (*)" type="text"

                fullWidth margin="normal" variant="outlined" onChange={this.handleChange}
                value={this.state.fields["usuarioNombreUsuario"]}
              />
            </Grid>

            <Grid item xs={3} className={this.props.classes.gridForm}>
              <TextField id="usuarioContrasena"
                label="Clave (*)"
                fullWidth margin="normal" variant="outlined" onChange={this.handleChange}
                value={this.state.fields["usuarioContrasena"]}
                type='password'
              />
            </Grid>
          </Grid>

          <Grid container spacing={4}>

            <Grid item xs={3} className={this.props.classes.gridForm}>
              <TextField id="usuarioFechaNacimiento"
                fullWidth margin="normal" variant="outlined"
                onChange={this.handleChange}
                value={this.state.fields["usuarioFechaNacimiento"]}
                type="date"
                label="Fecha Nacimiento"
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>

            <Grid item xs={3} className={this.props.classes.gridForm}>
              <PSelect
                namelabel="Tipodocumento (*)"
                id="tipdocCodigo"
                namelineInput="tipodocumento"
                fieldVisible="tipdocNombre"
                fieldCode="tipdocCodigo"
                Table="Tipodocumento"
                Vista="true"
                Where="true"
                useChildren={false}
                onChange={this.handleChange}
                value={this.state.fields["tipdocCodigo"]}
              />
            </Grid>
            <Grid item xs={3} className={this.props.classes.gridForm}>
              <TextField id="usuarioNumeroDocumento" label="Documento (*)" type="text"

                fullWidth margin="normal" variant="outlined"
                onChange={this.handleChange}
                value={this.state.fields["usuarioNumeroDocumento"]}
              />
            </Grid>

          </Grid>

          <Grid container spacing={4}>
            <Grid item xs={3} className={this.props.classes.gridForm}>
              <TextField id="usuarioCorreoElectronico" label="Correo Electronico (*)" type="text"

                fullWidth margin="normal" variant="outlined"
                onChange={this.handleChange}
                value={this.state.fields["usuarioCorreoElectronico"]}
              />
            </Grid>
            <Grid item xs={3} className={this.props.classes.gridForm}>
              <TextField id="usuarioNotas" label="Notas (*)" type="text-area"

                fullWidth margin="normal" variant="outlined"
                onChange={this.handleChange}
                value={this.state.fields["usuarioNotas"]}
              />
            </Grid>
            <Grid item xs={3} className={this.props.classes.gridForm}>
              <PSelect
                id="usuarioEstado"
                useChildren={true}
                value={this.state.fields["usuarioEstado"]}
                onChange={this.handleChange}
                namelabel="Estado (*)"
              >
                <option value="ACTIVO">ACTIVO</option>
                <option value="INACTIVO">INACTIVO</option>
              </PSelect>
            </Grid>

          </Grid>

          <Grid container spacing={10} >
            <Grid item xs={3} className={this.props.classes.gridForm}>
              <TextField id="usuarioAvatar" label="Avatar (*)" type="text"

                fullWidth margin="normal" variant="outlined"
                onChange={this.handleChange}
                value={this.state.fields["usuarioAvatar"]}
              />
            </Grid>
          </Grid>

          <Grid container spacing={10} >
            <Grid item xs={3} className={this.props.classes.gridForm}>
              <Textfieldlabel label="Usuario" value={Utils.getFromLocalStorage('userInfo').usuarioNombreCompleto} />
            </Grid>
            <Grid item xs={3} className={this.props.classes.gridForm}>
              <Textfieldlabel label="Fecha Creacion" value={this.state.fields.createdAt} />
            </Grid>
            <Grid item xs={3} className={this.props.classes.gridForm}>
              <Textfieldlabel label="Fecha Modificacion" value={this.state.fields.updatedAt} />
            </Grid>
          </Grid>

          <Grid>
            <CustomizedExpansionPanel tittle="PERMISOS X ALMACEN +++">
              <Datagrid  dataDatagrid={this.handleDatagrid} datos={this.state.dataDatagridUsuarioAlmacenes}/>
            </CustomizedExpansionPanel>
          </Grid>

          <CustomizedExpansionPanel tittle="PERMISOS X CLIENTE +++">
              <Datagrid dataDatagrid={this.handleDatagrid} datos={this.state.dataDatagridUsuarioClientes}/>
          </CustomizedExpansionPanel>

          <Grid>
            <CustomizedExpansionPanel tittle="PERMISOS X SUCURSAL +++">
              <Datagrid dataDatagrid={this.handleDatagrid} datos={this.state.dataDatagridUsuarioSucursales}/>
            </CustomizedExpansionPanel>
          </Grid>

          <CustomizedExpansionPanel tittle="PERMISOS X PAGINA +++">
              <Datagrid dataDatagrid={this.handleDatagrid} datos={this.state.dataDatagridUsuarioPaginas}/>
          </CustomizedExpansionPanel>   

        </form>
        <div><Buttoncontrol

          saveData={this.state.fields}
          moduleName={this.props.match.params.module}
          save={this.save}
          primaryFields={['usuarioCodigo']}

        /></div>
      </Paper>
    );
  }
}

Usuario.propTypes = {
  onClick: PropTypes.func.isRequired,
  enqueueSnackbar: PropTypes.func.isRequired,
};

const MyApp = withRouter(withSnackbar(withStyles(Styles, { withTheme: true })(Usuario)));

function IntegrationNotistack() {
  return (
    <SnackbarProvider maxSnack={1}
      action={[
        <Button variant="text" color="primary" size="small">
          {'X'}
        </Button>
      ]}

    >
      <MyApp />
    </SnackbarProvider>
  );
}


export default IntegrationNotistack;